<template>
  <div id='paymentresult'>
       <NavTop title='支付结果' :islink='true' linkurl='/orderlist'/>
       <van-empty
        class="custom-image"
        :image="result==1?okimg:failimg"
        :description="result==1?'支付成功':'支付失败'"
        />
  </div>
</template>
<script>
import { Empty } from 'vant';
import NavTop from '@/components/navtop'
import payOK from '@/assets/img/payok.svg'
import payFail from '@/assets/img/payfail.svg'
export default {
   name: 'paymentresult',
   data() {
      return{
         okimg:payOK,
         failimg:payFail,
         result:1
      }
   }, 
   created(){
      this.result=this.$route.params.status=='fail'? 0:1
   },
   components: {
        [Empty.name]:Empty,
        NavTop
   }
}
</script>
<style scoped>
#paymentresult{background-color:#fff;min-height: 100vh;padding-top:60px;z-index:999;}
 .custom-image .van-empty__image {
    width: 1.0rem;
    height: 1.0rem;
  }
::v-deep .van-empty__image{width:1rem;height:1rem;}  
</style>